import * as types from '../constants'
import { Record, Map, List } from 'immutable'

const propertiesRecord = Record({
  data: Map(),
  count: 1,
  offset: 0,
  isLoading: false,
  error: null,
  queryAddress: '',
  loc: Map({
    lat: parseFloat(process.env.REACT_APP_DEFAULT_LAT),
    lng: parseFloat(process.env.REACT_APP_DEFAULT_LNG),
  }),
  selected: null,
  cluster: List(),
  viewPort: Map(),
})

const initialState = new propertiesRecord()

export default (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_PROPERTIES_SUCCESS: {
      const newState = state.merge({
        data: action.offset > 0 ? state.get('data').merge(Map(action.data)) : Map(action.data),
        count: action.count,
        isLoading: false,
        offset: action.offset,
        error: null,
      })
      return newState
    }
    case types.FETCH_PROPERTIES_LOADING: {
      return state.set('isLoading', true)
    }
    case types.FETCH_PROPERTIES_ERROR: {
      return state.merge({ isLoading: false, queryAddress: '', error: null })
    }
    case types.FETCH_LOCATION_SUCCESS: {
      return state.merge({
        loc: Map(action.loc),
        isLoading: false,
        queryAddress: action.address,
        error: null,
        viewPort: action.viewPort,
      })
    }
    case types.FETCH_LOCATION_ERROR: {
      return state.merge({ loc: Map(), isLoading: false, error: action.error })
    }
    case types.MAP_MARKER_HOVER: {
      return state.set('selected', action.id)
    }
    case types.PAGINATE_FROM_MAP: {
      return state.merge({
        data: Map(action.data),
        isLoading: false,
        offset: action.offset,
        error: null,
      })
    }
    case types.FETCH_ZILLOW_ERROR: {
      return state.set('error', action.error)
    }
    case types.FLAG_PROPERTY: {
      return state.merge({
        data: state.get('data').delete(action.id),
        count: state.get('count') - 1,
      })
    }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/properties.js